import React from 'react';

import { Spin, Typography } from 'antd';

import type { ICardApiResponse } from 'v2/interfaces/customer';

import { Icon } from '@eduzz/ui-antd-theme';

import type { ICard } from '../index';
import PreviewCard from '../previewCard';

interface IProps {
  cardsList: ICardApiResponse[];
  isLoadingCards?: boolean;
  selectedCard?: ICard;
  onCardClick?: (card: ICard) => void;
}

const ListCards = ({ cardsList, isLoadingCards, selectedCard, onCardClick }: IProps) => {
  if (isLoadingCards) {
    return (
      <div className='flex flex-col items-center gap-2 py-4'>
        <Spin />
        <Typography.Text type='secondary'>Carregando formas de pagamento cadastradas</Typography.Text>
      </div>
    );
  }

  if (!cardsList?.length)
    return (
      <Typography.Text type='secondary' className='text-sm'>
        Nenhuma forma de pagamento cadastrada encontrada.
      </Typography.Text>
    );

  return (
    <div className='flex flex-wrap items-center justify-center gap-4'>
      {cardsList.map(card => {
        const currentCard: ICard = {
          id: card.id,
          name: card.holder,
          number: card.number,
          cvc: '',
          expiry: '',
          issuer: card.flag
        };
        const isSelected = selectedCard?.id === currentCard.id;

        return (
          <div
            key={card.id}
            className='relative w-full max-w-72.5 origin-center scale-90 cursor-pointer transition-transform duration-200 hover:scale-95 aria-selected:scale-100'
            aria-selected={isSelected}
            onClick={() => onCardClick?.(currentCard)}
          >
            {isSelected && (
              <Icon.CircleCheck
                size={36}
                className='absolute -top-2 -right-2 z-1 rounded-full bg-(--uizz-antd-color-bg-container) text-(--uizz-antd-color-primary)'
              />
            )}
            <PreviewCard card={currentCard} />
          </div>
        );
      })}
    </div>
  );
};

export default ListCards;
